// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"39d47203","325":"39d47203","677":"7807cc39"}[chunkId] + ".chunk.css";
};